import ImageThree from '../images/1.jpg'
import ImageFour from '../images/ssk.jpg'
import ImageOne from '../images/LAU_3951.jpg'
import ImageTwo from '../images/Hajo-am-Miscantes-076.jpg'


export const SliderData = [
  {
    title: 'Tourismus Dienstleistungen',
    path: '/Tour',
    label: 'Mehr erfahren',
    image: ImageOne,
    alt: 'Mehr erfahren sehen'
  },
  {
    title: 'Vorträge',
    subtitle: 'Südamerika, Mittelamerika, Karibik, Antarktis und Subantarktis, Arktis, Europa und Allgemeine Themen.',
    path: "/video",
    label: 'Video ansehen',
    image: ImageTwo,
    alt: 'Video'
  },
  {
    title: 'Beratung und Coaching',
    subtitle: 'Korrekturen von Vorträgen, Präsentationen, Texten und Sendungen, erstellen von Spezial-Vorträgen.',
    path: '/contact',
    label: 'Kontakt',
    image: ImageThree,
    alt: 'Kontakt'
  },
  {
    title: 'Scouting',
    subtitle: 'Erkunden und bewerten von touristischen Zielen: Landschaft, Natur, Kultur, Hotels und Restaurants.',
    path: '/contact',
    label: 'Kontakt',
    image: ImageFour,
    alt: 'Kontakt'
  },
];